// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Game Alert Utility
 * Centralized system for dispatching game alerts to the alert history
 * Uses EventBus for type-safe event management
 */

import EventBus, { EVENT_TYPES } from '../system/EventBus';

/**
 * Dispatch a game alert that will be logged in the alert history
 * @param {string} message - The alert message
 * @param {string} severity - Alert severity: 'info', 'warning', 'critical', 'success'
 */
export const dispatchGameAlert = (message, severity = 'info') => {
  EventBus.emit(EVENT_TYPES.GAME_ALERT, { message, severity });
};

// Convenience functions for different alert types
export const alertInfo = (message) => dispatchGameAlert(message, 'info');
export const alertWarning = (message) => dispatchGameAlert(message, 'warning');
export const alertCritical = (message) => dispatchGameAlert(message, 'critical');
export const alertSuccess = (message) => dispatchGameAlert(message, 'success');

const GameAlert = {
  dispatch: dispatchGameAlert,
  info: alertInfo,
  warning: alertWarning,
  critical: alertCritical,
  success: alertSuccess
};

export default GameAlert;